import { Pipe, PipeTransform } from '@angular/core';
import { Train } from '../../trains/models/train';
import { MonitoredTrain } from '../models/monitored-train';
import { ZabbixOverviewService } from '../services/zabbix-overview.service';

@Pipe({
  name: 'trainStructure'
})
export class TrainStructurePipe implements PipeTransform {

  constructor(
    private zabbixOverviewService: ZabbixOverviewService
  ) {

  }

  transform(currentTrain: MonitoredTrain, tree?: any): unknown {
      if (currentTrain && currentTrain.customZabbixConfig && currentTrain.customZabbixConfig.coachNames && currentTrain.customZabbixConfig.coachNames .length > 0) {
          currentTrain.structure.deviceGroups.forEach(function (deviceGroup, i) {
              deviceGroup.name = currentTrain.customZabbixConfig.coachNames[i].customName;
          });
      }
      const hashStructure = this.zabbixOverviewService.fillHashCodes([currentTrain.structure]);
      const newStructure = this.zabbixOverviewService.fillPriorities(hashStructure);
      tree = tree ? this.zabbixOverviewService.reloadOldStructure(tree, newStructure) : newStructure;
      tree[0].issues = currentTrain.issues;
      return tree; 
  }
}
